import { Component, Inject } from '@angular/core'
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog'
import { interval, filter, map, tap, switchMap, of } from 'rxjs'
import { ShoutlyEidSeBankIdProviderInfo, ShoutlyEidTransactionResponse } from '../../auth/models/auth.model'

export interface BankIDDialogData {
  eidTransaction?: ShoutlyEidTransactionResponse
}

@Component({
  selector: 'shared-bankid-dialog',
  templateUrl: './bankid-dialog.component.html',
  styleUrls: ['./bankid-dialog.component.scss']
})
export class BankidDialogComponent {
  constructor(
    public dialogRef: MatDialogRef<BankidDialogComponent>,
    @Inject(MAT_DIALOG_DATA) public data: BankIDDialogData
  ) { }

  public get bankid_url(): string {
    return this.getQrString(this.data?.eidTransaction?.providerInfo?.seBankID)
  }

  public random: string

  qrString$ = interval(2000)
    .pipe(
      switchMap(() => of(this.data.eidTransaction)),
      filter((eidTransaction) => !!eidTransaction?.providerInfo?.seBankID.autoStartToken),
      tap((eidTransaction) => {
        if(eidTransaction.status === "failed"){
          this.dialogRef.close(false)
        }
        if(eidTransaction.status === "complete"){
          this.dialogRef.close(true)
        }
      }),
      map((eidTransaction) => {
        const res = eidTransaction.providerInfo?.seBankID?.qrData;
        return res
      })
    )

  getQrString(bankId: ShoutlyEidSeBankIdProviderInfo): string {
    const autoStartToken = bankId?.qrData

    if (!autoStartToken) {
      console.log('Missing autoStartToken.')
      return null
    }

    return autoStartToken
  }

  public openBankIdApp() {
    const res = `${this.bankid_url}&redirect=null`
    const newWindow = window.open(res, '_blank')

    if (newWindow) {
      setTimeout(() => {
        newWindow.close()
      }, 1000) // Adjust the timeout as needed
    }
  }

}
